import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        flexWrap: 'wrap',
        paddingLeft: 25,
        paddingRight: 25,
        gap: 20
    },
    card: {
        backgroundColor: '#fff',
        marginTop: 20,
        borderRadius: 10,
        width: 300,
    },
    frontCover: {
        width: '100%',
        height: 140,
        borderTopRightRadius: 10,
        borderTopLeftRadius: 10,
    },
    nameCategory: {
        position: 'absolute',
        marginTop: 110,
        textAlign: 'center',
        color: '#fff',
        fontWeight: 'bold',
        width: '100%',
    },
    contentDescription: {
        padding: 25,
        marginTop: 10
    },
    description: {
        fontSize: 16,
        fontWeight: '400',
        lineHeight: 16
    },
    contentBtn: {
        alignItems: 'center',
        width: '100%',
        paddingBottom: 60,
        flex: 1
    },
    button: {
        position: 'absolute',
        bottom: 0
    },
    btn: {
        padding: 10,
        borderRadius: 20,
        width: 200,
        height: 40,
        marginBottom: 20
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: '500',
    },
});

export default styles;
